module.exports = __webpack_public_path__ + "static/media/dowlode-page.e83c9260.png";